import React from 'react';
import { Section } from '../ui/Section';
import { CheckSquare } from 'lucide-react';
export function SabotageChecklist() {
  const checklistItems = ['Manejas más de 30 minutos al trabajo cada día', 'Comes comida rápida o procesada más de 3 veces por semana', 'Duermes menos de 6 horas la mayoría de las noches', 'Tu nivel de estrés está por las nubes constantemente', 'No haces ejercicio regular (o solo haces cardio)', 'Tomas más de 2 bebidas alcohólicas por semana', 'Te sientes cansado incluso después de dormir 8 horas'];
  return <Section className="bg-brand-card/30" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-white" data-id="element-155">
          ¿Cuántos de estos sabotajes reconoces en tu día a día?
        </h2>

        <div className="bg-[#0f0f15] border border-white/10 rounded-2xl p-6 md:p-10 shadow-2xl" data-id="element-156">
          <div className="space-y-4" data-id="element-157">
            {checklistItems.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg bg-white/5 border border-white/5 hover:bg-white/10 transition-colors" data-id="element-158">
                <div className="mt-0.5 text-brand-danger" data-id="element-159">
                  <CheckSquare className="w-6 h-6 fill-brand-danger/20" data-id="element-160" />
                </div>
                <span className="text-lg text-gray-200 font-medium" data-id="element-161">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="mt-10 p-6 bg-brand-danger/10 border border-brand-danger/30 rounded-xl text-center" data-id="element-162">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-163">
              Si marcaste 3 o más, tu TSA está siendo{' '}
              <span className="text-brand-danger" data-id="element-164">bloqueada activamente</span>.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}